export default __webpack_public_path__ + "static/media/logo.8bc73621.jpg";